export const PRIVACY_POLICY_PATH = '/privacy_policy';
